import { useNavigate } from 'react-router-dom';
import { ResetPasswordForm } from 'ui/Form/auth/ResetPasswordForm';
import useQueryApiClient from 'utils/useQueryApiClient';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { LoginStyleContainer } from './LoginStyleContainer';
import PublicRoute from 'enums/publicRoutes';

export const ResetPassword = () => {
  const navigate = useNavigate();
  const [notificationApi, contextHolder] = notification.useNotification();
  const intl = useIntl();
  const { appendData } = useQueryApiClient({
    request: {
      url: `api/v2/forgot-password`,
      method: 'POST',
    },
    onSuccess: () => {
      openNotification(intl.formatMessage({ id: 'password.reset_email_sent' }));
      setTimeout(() => {
        navigate(PublicRoute.HOME);
      }, 5000);
    },
    onError: () => {
      openNotification(intl.formatMessage({ id: 'password.reset_email_sent' }));
      setTimeout(() => {
        navigate(PublicRoute.HOME);
      }, 5000);
    },
  });

  const openNotification = (message: string) => {
    notificationApi['info']({
      message: message,
      showProgress: true,
      pauseOnHover: true,
      duration: 5,
    });
  };

  return (
    <LoginStyleContainer>
      {contextHolder}
      <ResetPasswordForm appendData={appendData} />
    </LoginStyleContainer>
  );
};
